
import React from "react";
import { Card } from "@/components/ui/card";
import { Users, MapPin, FileText, CalendarDays, MessageSquare } from "lucide-react";

interface AdminActionsProps {
  onUsersClick: () => void;
  onWorksitesClick: () => void;
  onReportsClick: () => void;
  onCalendarClick: () => void;
  onMessagesClick: () => void;
}

export const AdminActions: React.FC<AdminActionsProps> = ({
  onUsersClick,
  onWorksitesClick,
  onReportsClick,
  onCalendarClick,
  onMessagesClick
}) => {
  return (
    <section className="mb-6">
      <h2 className="text-lg font-bold text-[#333333] mb-4">Actions administrateur</h2>
      <div className="grid grid-cols-2 gap-4">
        <Card 
          className="bg-white rounded-lg shadow-sm p-4 hover:shadow-md transition-shadow cursor-pointer"
          onClick={onUsersClick}
        >
          <div className="flex items-center space-x-3">
            <Users className="h-6 w-6 text-[#BD1E28]" />
            <div>
              <h3 className="font-medium text-[#333333]">Employés</h3>
              <p className="text-sm text-[#666666]">Gérer les utilisateurs</p>
            </div>
          </div>
        </Card>

        <Card 
          className="bg-white rounded-lg shadow-sm p-4 hover:shadow-md transition-shadow cursor-pointer"
          onClick={onWorksitesClick}
        >
          <div className="flex items-center space-x-3">
            <MapPin className="h-6 w-6 text-[#BD1E28]" />
            <div>
              <h3 className="font-medium text-[#333333]">Chantiers</h3>
              <p className="text-sm text-[#666666]">Gérer les sites</p>
            </div>
          </div>
        </Card>

        <Card 
          className="bg-white rounded-lg shadow-sm p-4 hover:shadow-md transition-shadow cursor-pointer"
          onClick={onReportsClick}
        >
          <div className="flex items-center space-x-3">
            <FileText className="h-6 w-6 text-[#BD1E28]" />
            <div>
              <h3 className="font-medium text-[#333333]">Rapports</h3>
              <p className="text-sm text-[#666666]">Consulter les données</p>
            </div>
          </div>
        </Card>

        <Card 
          className="bg-white rounded-lg shadow-sm p-4 hover:shadow-md transition-shadow cursor-pointer"
          onClick={onCalendarClick}
        >
          <div className="flex items-center space-x-3">
            <CalendarDays className="h-6 w-6 text-[#BD1E28]" />
            <div>
              <h3 className="font-medium text-[#333333]">Calendrier</h3>
              <p className="text-sm text-[#666666]">Voir le planning</p>
            </div>
          </div>
        </Card>

        <Card 
          className="bg-white rounded-lg shadow-sm p-4 hover:shadow-md transition-shadow cursor-pointer col-span-2"
          onClick={onMessagesClick}
        >
          <div className="flex items-center space-x-3">
            <MessageSquare className="h-6 w-6 text-[#BD1E28]" />
            <div>
              <h3 className="font-medium text-[#333333]">Messages internes</h3>
              <p className="text-sm text-[#666666]">Gérer la communication</p>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};
